module.exports = __webpack_public_path__ + "img/avatar_default.a0ef71e5.svg";